// extracted by mini-css-extract-plugin
export default {"share":"share_share__qxbyg","share__icon":"share_share__icon__4i7Th","copied":"share_copied__dB0YK"};